import React from 'react';
import '../Services.css';
import Image1 from '../../Gemco-Website-Images/Services/Industrial_plants.jpg';

const Service_two = () => {
  return (
    <div className='wp_sub_service'>
          <div className="container wp_sub_service_container">
              <div className="row wp_service_row">
                <div className="content-column">
                  <div className="inner-column wp_service_inner_column">
                    <div className='sec-title forseotitle wp_service_sec_title'>
                      <h1>CHW and District Cooling</h1>
                      <p>GEMCO's deepest and most technically advanced capability. Over 25 years delivering chilled
                        water systems for district cooling plants, data centres, airports and the UAE's most technically
                        demanding projects. From plant room design coordination to full network installation and
                        commissioning.</p>
                        <ul>
                          <li className="service_list_item">Chilled water pipe supply and installation — all sizes from 25mm to 600mm diameter</li>
                          <li className="service_list_item">Plant room mechanical works: chillers, cooling towers, primary and secondary pumps</li>
                          <li className="service_list_item">Grooved coupling and flanged pipe systems</li>
                          <li className="service_list_item">Full thermal insulation to specification</li>
                          <li className="service_list_item">Valve and actuator installation</li>
                          <li className="service_list_item">District cooling network connections and tie-ins</li>
                          <li className="service_list_item">Pressure testing</li>
                          <li className="service_list_item">flushing</li>
                          <li className="service_list_item">chemical dosing and commissioning</li>
                          <li className="service_list_item">As-built documentation and O&M</li>
                          <li className="service_list_item">manuals</li>
                        </ul>
                    </div>
                  </div>
                </div>
                <div className="image-column">
                  <img src={Image1} width="500" height="400" alt="" />
                </div>
              </div>
          </div>
        </div>
  )
}

export default Service_two